import DashboardProvider from "./context/DashboardProvider";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from "./layouts";
import Router from "./routes";
import ThemeConfig from './theme';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import './index.css';

// Create a client
const queryClient = new QueryClient()

export default function App() {
  return (
    <DashboardProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeConfig>
          <Layout>
            <ToastContainer></ToastContainer>
            <Router />
          </Layout>
        </ThemeConfig>
      </QueryClientProvider>
    </DashboardProvider>
  );
};
